import { useEffect, useState } from 'react'
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import Projectname from './Projectname/Projectname';
import axios from 'axios';
import { BASE_URL } from '../../config/axios';
import { AddProjectName } from './Projectname/AddProjectName';
import { AddProjectDetails } from './ProjectDetailsCrud/ProjectDetailsCRUD';
import Project from './ProjectDetailsCrud/Project';
import SectionFilter from './ProjectDetailsCrud/SectionFilter';
import ProjectFilter from './Projectname/ProjectFilter';

const Mainproject = () => {

    const [toggleState, setToggleState] = useState(1);
    const [buffer, setBuffering] = useState(false);

    const [projectName, setProjectName] = useState([]);
    const [project, setProject] = useState([]);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1: return "Project Details";
            case 2: return "Section Details";
            default: return "Project";
        }
    };

    const getProjectname = async (filters = null) => {
        try {
            let res;
            if (filters) {
                const url = `${BASE_URL}/dpr/projectdetailsmultiplefilter/${filters.project || "null"
                    }/${filters.sector || "null"
                    }/${filters.workType || "null"
                    }/${filters.companyName || "null"
                    }/${filters.loaStartDate || "null"
                    }/${filters.loaEndDate || "null"
                    }/${filters.completionStartDate || "null"
                    }/${filters.completionEndDate || "null"
                    }/`;

                console.log("🔥 PROJECT FILTER:", url);
                res = await axios.get(url);
            } else {
                res = await axios.get(`${BASE_URL}/dpr/projectdetails/`);
            }
            setProjectName(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const getProject = async (filters = null) => {
        setBuffering(true);
        try {
            let result;
            if (filters) {
                const safe = (val) => (val ? val : "null");

                const url = `${BASE_URL}/dpr/sectionmultiplefilter/${safe(filters.project)
                    }/${safe(filters.section)
                    }/${safe(filters.location)
                    }/${safe(filters.workStage)
                    }/${safe(filters.minLength)
                    }/${safe(filters.maxLength)
                    }/${safe(filters.minCost)
                    }/${safe(filters.maxCost)
                    }/`;

                console.log("🔥 SECTION FILTER API:", url);
                result = await axios.get(url);
            } else {
                result = await axios.get(`${BASE_URL}/dpr/project/`);
            }
            setProject(result.data);
        } catch (err) {
            console.error("Error fetching section data:", err);
        } finally {
            setBuffering(false);
        }
    };

    // ✅ Handler for ProjectFilter (Tab 1)
    const handleProjectFilter = (filters) => {
        getProjectname(filters);
    };

    // ✅ Handler for SectionFilter (Tab 2)
    const handleSectionFilter = (filters) => {
        getProject(filters);
    };

    useEffect(() => {
        getProjectname();
        getProject();
    }, []);

    return (
        <>
            <div>
                <Dashboardnavbar name={getSelectedTitle()} url={"Project Management"} />

                <div className="content-tabs">
                    <div className='toggle-button-area flex-row justify-between' style={{ padding: "15px 30px" }}>
                        <div className='flex-row justify-between' style={{ width: "100%" }}>

                            <div>
                                <button
                                    className={toggleState === 1 ? "dashboardcomponent-tabs dashboardcomponent-active-tabs" : "dashboardcomponent-tabs"}
                                    onClick={() => setToggleState(1)}
                                >
                                    Project Details
                                </button>
                                <button
                                    className={toggleState === 2 ? "dashboardcomponent-tabs dashboardcomponent-active-tabs" : "dashboardcomponent-tabs"}
                                    onClick={() => setToggleState(2)}
                                >
                                    Section Details
                                </button>
                            </div>

                            {toggleState === 1 ? (
                                <AddProjectName getProjectname={getProjectname} useFor="table" />
                            ) : (
                                <AddProjectDetails
                                    getProject={getProject}
                                    project={project}
                                    ProjectDetails={projectName}
                                />
                            )}

                        </div>
                    </div>

                    <div style={{ padding: "0 30px" }}>

                        {/* ✅ TAB 1 — Project Details */}
                        {toggleState === 1 && (
                            <>
                                <ProjectFilter onApply={handleProjectFilter} />
                                <Projectname
                                    projectName={projectName}
                                    getProjectname={getProjectname}
                                    getProject={getProject}
                                    buffer={buffer}
                                />
                            </>
                        )}

                        {/* ✅ TAB 2 — Section Details */}
                        {toggleState === 2 && (
                            <>
                                <SectionFilter onApply={handleSectionFilter} sectionData={project} />
                                <Project
                                    project={project}
                                    getProject={getProject}
                                    buffer={buffer}
                                    ProjectDetails={projectName}
                                />
                            </>
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};

export default Mainproject;